import { RegularExpressions } from "../../Helpers/RegularExpression";
import { ValForm, ValFormReg } from "../../Validators/ValForms";

export const ValCredito = (state) => {
    // const nuevousado = ValForm("Nuevo o Usado", state.nuevousado);
    const ejercicio = ValFormReg(
        "Ejercicio",
        state.ejercicio,
        RegularExpressions.TextOnlyNumber
    );
    const periodo = ValFormReg(
        "Periodo",
        state.periodo,
        RegularExpressions.TextOnlyNumber
    );
    const interes = ValFormReg(
        "Interes",
        state.interes,
        RegularExpressions.TextOnlyNumber
    );
    const interes2 = ValFormReg(
        "Interes2",
        state.interes2,
        RegularExpressions.TextOnlyNumber
    );

    var isValid = true;
    var mensaje = "";
    if (ejercicio.isValid === false) {
        state.bejercicio = true;
        isValid = false;
        mensaje += ejercicio.mensaje;
    }
    if (periodo.isValid === false) {
        state.bperiodo = true;
        isValid = false;
        mensaje += periodo.mensaje;
    }
    if (interes.isValid === false) {
        state.binteres = true;
        isValid = false;
        mensaje += interes.mensaje;
    }
    if (interes2.isValid === false) {
        state.binteres2 = true;
        isValid = false;
        mensaje += interes2.mensaje;
    }
    if (isValid === false) {
        return { isValid, state, mensaje };
    } else {
        return {
            isValid,
            post: {
                idinteres: 0,
                ejercicio: state.ejercicio,
                periodo: state.periodo,
                interes: state.interes,
                interes2: state.interes2,
                estatus: 0
            },
        };
    }
};
